/**
 * Builds a DOM id that is safe to interpolate into a CSS selector.
 *
 * CSS identifiers may not start with a digit. react-chessboard builds selectors
 * like `#${id}-square-e5` by hand, so handing it a raw Lichess puzzle id — which
 * routinely starts with digits, e.g. "00eNa" — throws
 * `SyntaxError: '#00eNa-square-e5' is not a valid selector` the moment a piece
 * is hovered or dragged. The failure is invisible until then, because the
 * library also uses getElementById, which tolerates a leading digit.
 */
export function cssSafeId(prefix: string, value: string): string {
  return `${prefix}-${value.replace(/[^a-zA-Z0-9_-]/g, '-')}`
}
